import Phaser from 'phaser'
import {
    CST
} from '../CST'

export default class PreloadScene extends Phaser.Scene {

    constructor() {
        super(CST.SCENES.BOOT);
    }

    preload() {
        // load assets
        this.load.image("loading_bg", "assets/loading_background.png");
    }

    create() {
        this.scene.start(CST.SCENES.PRELOAD);
    }

    upload() {}
}